export default __webpack_public_path__ + "static/media/clipsMenu.c4094ec3.svg";